import Swal from "sweetalert2";

import { configureOmiseSDK } from "./configureOmise";

export class ApplePayFlow {
	/**
	 * initializa
	 */
	paymentLabel = null;
	paymentAmount = null;
	data = null;

	/**
	 * result
	 */
	paymentNetwork = null;
	paymentToken = null;

	initializeEpayment = async () => {
		throw new Error("initializeEpayment is required");
	};

	createOmiseCharge = async () => {
		throw new Error("initializeEpayment is required");
	};

	constructor({ paymentAmount, data, paymentLabel, initializeEpayment, createOmiseCharge }) {
		this.paymentAmount = paymentAmount;
		this.data = data;
		this.paymentLabel = paymentLabel;
		if (!initializeEpayment) {
			throw new Error("initializeEpayment is required");
		}

		this.initializeEpayment = initializeEpayment;

		if (!createOmiseCharge) {
			throw new Error("createOmiseCharge is required");
		}

		this.createOmiseCharge = createOmiseCharge;
		configureOmiseSDK();
	}

	async init() {
		// Consider falling back to Apple Pay JS if Payment Request is not available.
		if (typeof PaymentRequest === "undefined") {
			throw new Error("Apple Pay (PaymentRequest) is not available in this browser");
		}

		// Define PaymentMethodData
		const paymentMethodData = [
			{
				supportedMethods: "https://apple.com/apple-pay",
				data: {
					version: 3,
					merchantIdentifier: "merchant.omise.sg.prod",
					merchantCapabilities: ["supports3DS"],
					supportedNetworks: ["amex", "discover", "masterCard", "visa"],
					countryCode: "SG",
				},
			},
		];
		// Define PaymentDetails
		const paymentDetails = {
			total: {
				label: this.paymentLabel,
				amount: {
					value: this.paymentAmount,
					currency: "SGD",
					country: "SG",
				},
			},
		};

		// Define PaymentOptions
		const paymentOptions = {
			requestPayerName: false,
			requestBillingAddress: false,
			requestPayerEmail: false,
			requestPayerPhone: false,
			requestShipping: false,
			shippingType: "shipping",
		};

		// Create PaymentRequest
		const request = new PaymentRequest(paymentMethodData, paymentDetails, paymentOptions);

		request.onmerchantvalidation = (event) => {
			// Call your own server to request a new merchant session.
			// const merchantSessionPromise = validateMerchant();
			const merchantSessionPromise = fetch(
				(window.location.href.includes("learn.sda.edu.sg")
					? "https://tms.fcacademy.com.sg"
					: "https://staging-tms.fcacademy.com.sg") +
					"/api/authorizeMerchant?event_reg_id=" +
					this.data.eventregform_id +
					"&domain=" +
					(window.location.href.includes("learn.sda.edu.sg")
						? "learn.sda.edu.sg"
						: "falcomm-tms.fcacademy.com.sg"),
			)
				.then((res) => res.json()) // Parse the response as JSON.
				.catch((err) => {
					console.error("Error fetching merchant session", err);
				});

			event.complete(merchantSessionPromise);
			console.log("merchantSessionPromise:", merchantSessionPromise);
		};

		request.onpaymentmethodchange = (event) => {
			if (event.methodDetails.type !== undefined) {
				// Define PaymentDetailsUpdate based on the selected payment method.
				// No updates or errors needed, pass an object with the same total.
				const paymentDetailsUpdate = {
					total: paymentDetails.total,
				};
				event.updateWith(paymentDetailsUpdate);
			}
			// else if (event.methodDetails.couponCode !== undefined) {
			// 	// Define PaymentDetailsUpdate based on the coupon code.
			// 	const total = calculateTotal(event.methodDetails.couponCode);
			// 	const displayItems = calculateDisplayItem(event.methodDetails.couponCode);
			// 	const shippingOptions = calculateShippingOptions(event.methodDetails.couponCode);
			// 	const error = calculateError(event.methodDetails.couponCode);

			// 	event.updateWith({
			// 		total: total,
			// 		displayItems: displayItems,
			// 		shippingOptions: shippingOptions,
			// 		modifiers: [
			// 			{
			// 				data: {
			// 					additionalShippingMethods: shippingOptions,
			// 				},
			// 			},
			// 		],
			// 		error: error,
			// 	});
			// }
		};

		request.onshippingoptionchange = (event) => {
			// Define PaymentDetailsUpdate based on the selected shipping option.
			// No updates or errors needed, pass an object with the same total.
			const paymentDetailsUpdate = {
				total: paymentDetails.total,
			};
			event.updateWith(paymentDetailsUpdate);
		};

		request.onshippingaddresschange = (event) => {
			// Define PaymentDetailsUpdate based on a shipping address change.
			const paymentDetailsUpdate = {};
			event.updateWith(paymentDetailsUpdate);
		};

		const response = await request.show();
		let applepay_paymentToken = response.details.token.paymentData;
		let applepay_paymentNetwork = response.details.token.paymentMethod.network;

		if (!applepay_paymentToken) {
			throw new Error("Apple Pay unable to get payment token");
		}
		if (!applepay_paymentNetwork) {
			throw new Error("Apple Pay unable to get payment network");
		}

		this.paymentToken = applepay_paymentToken;
		this.paymentNetwork = applepay_paymentNetwork;
		await response.complete("success");

		return {
			paymentToken: this.paymentToken,
			paymentNetwork: this.paymentNetwork,
		};
	}

	async processPayment() {
		await this.init();

		const epaymentPayload = {
			...this.data,
			omiseToken: "",
			omiseSource: "",
			payment_method: "applepay",
		};

		const epaymentResponse = await this.initializeEpayment(epaymentPayload);
		if (!epaymentResponse.status == 1) {
			throw new Error("Unexpected error while creating payment record, expecting 1");
		}

		const tokenParameters = {
			method: "applepay",
			data: JSON.stringify(this.paymentAmount),
			merchant_id: "merchant.omise.sg.prod",
			brand: this.paymentNetwork,
		};

		const omiseToken = await new Promise((resolve, reject) => {
			window.Omise.createToken("tokenization", tokenParameters, function (statusCode, response) {
				if (response.object == "error") {
					reject(response);
					Swal.fire({
						title: "",
						html:
							"Error: " +
							response.code
								.toLowerCase()
								.replace("_", " ")
								.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()) +
							" - " +
							response.message
								.toLowerCase()
								.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()),
						icon: "error",
					});
				} else {
					resolve(response.id);
				}
			});
		});

		const chargePayload = {
			payment_id: epaymentResponse.data.payment_id,
			payment_mode: epaymentResponse.data.payment_mode,
			omiseToken: omiseToken,
		};

		return await this.createOmiseCharge(chargePayload);
	}
}
